import clsx from 'clsx';

export const formatTonnageBtu = (btu: number) =>
  Math.round(btu).toLocaleString('en-US');

export const tonnageTileClassName = (selected: boolean) =>
  clsx(
    'rounded-lg border py-1.5 text-center text-xs leading-snug',
    selected
      ? 'cursor-pointer border-blue-600 bg-blue-50 font-semibold text-blue-800'
      : 'cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-gray-400'
  );
